export default __webpack_public_path__ + "static/media/line-dots.db2bf4fc.svg";